import { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { IItemComboBaseDTO } from "../../../../interfaces/base/IBase";

const UseComboOpciones = (isOpen: boolean) => {
    const [dataComboOpciones, setDataComboOpciones] = useState<IItemComboBaseDTO[]>([]);
    const comboBoxRefOpciones = useRef<IComboBox>(null);

    const onClickComboOpciones = () => comboBoxRefOpciones.current?.focus(true);

    const _openOption = useCallback(
        () => comboBoxRefOpciones.current?.focus(true),
        []
    );

    const _onkeyUpSearchOpciones = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefOpciones.current?.focus(false);
        } else {
            _openOption();
        }
    };

    const listarCombo = () => {
        setDataComboOpciones([
            { key: 'true', text: "SI" },
            { key: 'false', text: "NO" }
        ]);
    };

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen]);

    return {
        dataComboOpciones,
        onClickComboOpciones,
        _onkeyUpSearchOpciones,
        comboBoxRefOpciones
    };
}

export { UseComboOpciones }
